var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"icon-btn",class:{
    'icon-btn--active': _vm.active,
    'icon-btn--disabled': _vm.disabled,
  },attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleClick.apply(null, arguments)},"mousedown":function($event){$event.preventDefault();}}},[_c('iconic',{attrs:{"name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }